export default __webpack_public_path__ + "1f36a33.png";